import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Grid, makeStyles } from '@material-ui/core';
import { Button } from 'react-admin';
import { uniqueId } from 'lodash';
import expandableSelectStyles from '../../contents/component/ExpandableSelectStyles';
import { CONTENT_AUTOMATION_API_URL } from '../../../constants';
import { useAutomationContext } from '../../../common/AutomationContextProvider';

const fetchUrl = CONTENT_AUTOMATION_API_URL;

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: '1rem',
  },
}));

const useSharedStyles = expandableSelectStyles;

const FragmentsGenerator = ({ baseRecord, callback, setFragments }) => {
  const classes = useStyles();
  const sharedClasses = useSharedStyles();

  const { sonixId, startTimeParsed, endTimeParsed, showSnackbar } =
    useAutomationContext();

  // Fragment related
  const createFragment = useCallback(
    ({ text, textTranslations, startTime, endTime }) => {
      const newFragment = {
        ...baseRecord,
        fragmentKey: uniqueId(),
        text,
        textTranslations,
        startTime,
        endTime,
      };
      return newFragment;
    },
    [baseRecord],
  );

  const getFragments = useCallback(async () => {
    const response = await fetch(
      `${fetchUrl}/fragment/${sonixId}?start=${startTimeParsed}&end=${endTimeParsed}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );

    const results = await response.json();

    return results;
  }, [sonixId, startTimeParsed, endTimeParsed]);

  const onClickHandler = useCallback(async () => {
    if (!sonixId) {
      showSnackbar({
        message: 'No Sonix ID provided! Press "TRANSCRIBE" once.',
        severity: 'error',
      });
      return;
    }

    const newFragments = (await getFragments()).data.map((fragment) => {
      return createFragment(fragment);
    });
    setFragments((prevFragments) => [...prevFragments, ...newFragments]);
    showSnackbar({
      message: 'Fragments Generated',
      severity: 'success',
    });
    callback(newFragments);
  }, [
    sonixId,
    getFragments,
    callback,
    setFragments,
    createFragment,
    showSnackbar,
  ]);
  // Fragment related END
  return (
    <>
      <Grid
        container
        spacing={4}
        className={`${sharedClasses.tree}`}
        justify="center"
      >
        <Grid item>
          <div className={classes.root}>
            <Button
              variant="contained"
              color="primary"
              label="Generate Fragments From Transcripts"
              onClick={onClickHandler}
            />
          </div>
        </Grid>
      </Grid>
    </>
  );
};

FragmentsGenerator.propTypes = {
  baseRecord: PropTypes.objectOf({
    contentKey: PropTypes.string,
    languageCode: PropTypes.string,
  }).isRequired,
  callback: PropTypes.func,
  setFragments: PropTypes.func,
};

export default FragmentsGenerator;
